import React, { useRef, useState } from "react";
import { Box, makeStyles } from "@material-ui/core";

import { useSelector } from "react-redux";
import { getAuthInfo } from "store/slices/auth";

import Loading from "components/Common/Loading";
import { useTranslation } from "react-i18next";
import ChangePasswordForm from "views/Client/AccountSetting/Components/ChangePasswordForm";
import ChangeEmailForm from "views/Client/AccountSetting/Components/ChangeEmailForm";
import { changeEmail, changePassword, getMe } from "store/slices/auth";
import { reduceUpdateAdminUser } from "store/slices/admin";
import { reduceUpdateCompanyUser } from "store/slices/companyUser";
import { useDispatch } from "react-redux";
import AdminProfileForm from "./Component/Profile/AdminProfileForm";
import AppTabs from "components/CustomTabs/AppTabs";
import { SYSTEM_ROLE } from "config/AppConfig";
import OnBoardCompany from "views/User/OnBoard/Company/OnboardCompany";

const ProfileManagement = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const cpRef = useRef();
  const ceRef = useRef();

  const [loading, setLoading] = useState(false);
  
  const authInfo = useSelector(getAuthInfo) || {};
  const { role, id, email } = authInfo;

  const styles = makeStyles(() => ({
    subLabel: {
      marginBottom: "0.5rem",
      fontSize: "0.8rem",
    },
  }));
  const classes = styles();

  if (!role) {
    return <Loading />;
  }
  const submitChangePassword = async ({ confirmPass, newPass }) => {
    setLoading(true);
    if (confirmPass && newPass) {
      const result = await dispatch(
        changePassword({
          id: id,
          confirmPass: confirmPass,
          newPass: newPass,
        })
      );
      if (result.payload) {
        // cpRef && cpRef.current.resetForm();
      }
    }
    setLoading(false);
  };
  const submitChangeEmail = async ({ email }) => {
    setLoading(true);
    if (email) {
      const result = await dispatch(
        changeEmail({
          id: id,
          email: email,
        })
      );
      if (result.payload) {
        // ceRef && ceRef.current.resetForm();
        dispatch(getMe());
      }
    }
    setLoading(false);
  };
  const submitChangeProfile = async (form) => {
    const { firstName, lastName } = form;
    setLoading(true);
    let request = {
      id: id,
      firstName: firstName,
      lastName: lastName,
      permissions: authInfo.permissions
    };
    if (role === SYSTEM_ROLE.COMPANY) {
      request.companyId = authInfo.companyId;
      request.permissions = authInfo.permissions

    }
    const result = await dispatch(
      role === SYSTEM_ROLE.COMPANY ?
      reduceUpdateCompanyUser(request)
      : reduceUpdateAdminUser(request)
    );
    if (result.payload) {
      dispatch(getMe());
    }
    setLoading(false);
  };

  const tabs = [
    {
      tabLabel: t("label.myProfile"),
      tabContent: (
        <AdminProfileForm
          initData={authInfo}
          onSubmit={submitChangeProfile}
          isSubmitting={loading}
        />
      ),
    },
    {
      tabLabel: t("label.changePassword"),
      tabContent: (
        <React.Fragment>
            <ChangeEmailForm
            isSubmitting={loading}
            email={email}
            onSubmit={submitChangeEmail}
            formRef={ceRef}
          />
          
          <Box className={classes.subLabel}>{t("text.leavePasswordBlank")}</Box>
          <ChangePasswordForm
            isSubmitting={loading}
            onSubmit={submitChangePassword}
            formRef={cpRef}
          />
        </React.Fragment>
      ),
    },
  ];
  if (authInfo.role === SYSTEM_ROLE.COMPANY && authInfo.owner) {
    return <OnBoardCompany authInfo={authInfo} />;
  } else {
    return <AppTabs swipeable={false} tabs={tabs} />;
  }
};

export default ProfileManagement;
